<template>
	<div class="panel-header">
		<div class="text">{{title}}</div>
	</div>
</template>
<script>
export default {
	name:'panelTitle',
	props:['title']
}
</script>
<style lang="scss">
	.panel-header {
		font-size:16px; 
		color: #333333;
		padding: 0 10px;
		margin: 10px 0;
		height: 30px;
		.text{
			position: relative;
			margin-left: 10px;
			border:none;
			&::after {
				content: '';
				position: absolute;
				top: 5px;
				left: -15px;
				width: 5px;
				height: 17px;
				background-color: #333333;
			}
		}
	}
</style>